// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__accent[data-v-5a5d6fc5]{font-size:24px;font-weight:400;line-height:1.29;letter-spacing:normal}.text__accent.bold[data-v-5a5d6fc5]{font-weight:700}@media (max-width:575.98px){.text__accent.adaptive[data-v-5a5d6fc5]{font-size:20px;line-height:1.35}}", ""]);
// Exports
module.exports = exports;
